import WorkItemAttribute from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/work_item_attribute.vue?vue3';
import { parseSeconds, stringifyTime } from '~/lib/utils/datetime_utility';
import { sprintf, __ } from '~/locale';
export default {
    name: 'IssueTimeEstimate',
    i18n: {
        timeEstimate: __('Time estimate')
    },
    components: {
        WorkItemAttribute
    },
    inject: [
        'timeTrackingLimitToHours'
    ],
    props: {
        estimate: {
            type: Number,
            required: true
        }
    },
    computed: {
        title () {
            return stringifyTime(parseSeconds(this.estimate, {
                limitToHours: this.timeTrackingLimitToHours
            }), true);
        },
        timeEstimate () {
            return stringifyTime(parseSeconds(this.estimate, {
                limitToHours: this.timeTrackingLimitToHours
            }));
        }
    },
    methods: {
        createAriaLabel () {
            return sprintf(__(`Time estimate: %{estimate}`), {
                estimate: this.title
            });
        }
    }
};
